export var OWA_REFERENCE_ATTACHMENTS_ID = 'OwaReferenceAttachments';
var DISALLOWED_IDS = [
    'OWAHT',
    'OWAAM',
    OWA_REFERENCE_ATTACHMENTS_ID,
    'OwaReferenceAttachmentsEnd',
    'LPUrlAnchor',
    'LPImageAnchor',
];
export var DOWNLEVEL_CONTENT_CLASS = 'OLK-Hidden';
export default function shouldProcessLink(link, hiddenReferenceAttachments) {
    if (link.id) {
        if (DISALLOWED_IDS.filter(function (id) { return link.id.indexOf(id) === 0; }).length > 0) {
            return false;
        }
    }
    if (link.className.indexOf(DOWNLEVEL_CONTENT_CLASS) !== -1) {
        return false;
    }
    if (!link.href) {
        return false;
    }
    if (hiddenReferenceAttachments) {
        for (var i = 0; i < hiddenReferenceAttachments.length; i++) {
            if (isDescendant(hiddenReferenceAttachments[i], link)) {
                return false;
            }
        }
    }
    return true;
}
function isDescendant(parent, child) {
    var node = child;
    while ((node = node.parentNode)) {
        if (node === parent) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=shouldProcessLink.js.map